export const API_URL = `${process.env.API_URL}/api`;
export const API_KEY = process.env.API_KEY ?? '';
export const REDIRECTS_ENABLED = process.env.REDIRECTS_ENABLED === 'true';
export const FACEBOOK_ID = 'sepjq1j8hnt628k2q73ksk7tzyotsb';
export const LOCALE_COOKIE_NAME = 'NEXT_PREFERRED_LOCALE';
